import {keys, pick, isEmpty} from 'underscore'
import WAlertsMixin from '../w-alerts-mixin'

const PROPS = {
    /**
     * Array of validation errors
     */
    errors: {
        type: Array,
        default: () => []
    }
}

/**
 * @mixin
 */
export default {
    props: PROPS,
    mixins: [WAlertsMixin],
    computed: {
        wFormErrorAlertsProps () {
            const vm = this
            const propKeys = keys(PROPS)

            return pick(vm, propKeys)
        },
        formErrorAlerts () {
            const vm = this
            return vm.formErrorAlertsFormatted(vm.errors)
        },
        hasFormErrorAlerts () {
            return !isEmpty(this.formErrorAlerts)
        }
    }
}
